export default "__VITE_ASSET__BLGJJaKu__"